import styled from 'styled-components';
import { ApButtonSecondary, colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
  background-color: ${colors.greyBg};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 1137px;
  margin: 24px auto;
  background-color: ${colors.white};
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
  padding: 32px;
  &:first-child {
    margin-top: 32px;
  }
  input.react-autosuggest__input {
    height: 40px;
    border-color: ${colors.grey4};
    &:focus,
    &:hover {
      border-color: ${colors.green2};
    }
  }
`;

export const SectionTitle = styled.div`
  font-size: 19px;
  font-weight: 500;
  color: ${colors.grey7};
`;

export const SectionMainTitle = styled(SectionTitle)`
  font-size: 23px;
`;

export const SectionDescription = styled.div`
  font-size: 13px;
  font-weight: 400;
  color: ${colors.grey6};
  margin: 24px 0;
`;

export const SelectContainer = styled.div`
  display: flex;
  width: 170px;
`;

export const EditContainer = styled.div`
  height: 60px;
  padding-top: 20px;
  margin-right: 24px;
  display: flex;
`;

export const SelectYearDescription = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

export const InputLabel = styled.div`
  font-size: 13px;
  font-weight: 400;
  color: ${colors.grey5};
  margin-bottom: 4px;
`;

export const Divider = styled.div`
  height: 1px;
  background-color: ${colors.grey2};
  margin: 24px 0;
`;

export const TooltipContent = styled.div`
  cursor: pointer;
  margin-left: 6px;
  height: 24px;
`;

export const RadioContainer = styled.div`
  width: 512px;
  display: flex;
  justify-content: space-between;
`;

export const IndustryNameWrapper = styled.div`
  width: 560px;
  margin-right: 24px;
`;

export const ErrorRow = styled.div`
  position: relative;
  width: 100%;
  padding-left: 308px;
  color: ${colors.orange};
`;

export const ErrorText = styled.div`
  position: absolute;
  top: -12px;
  left: 308px;
  font-size: 13px;
  font-weight: 700;
`;

export const IndustryLabel = styled(InputLabel)`
  width: 294px;
  min-width: 294px;
  margin-right: 12px;
`;

export const AllocationLabel = styled(InputLabel)`
  width: 112px;
  min-width: 112px;
`;

export const CalculationsIntroText = styled.div`
  font-size: 13px;
  font-weight: 400;
  display: flex;
  justify-content: center;
  color: ${colors.grey5};
  letter-spacing: 0.3px;
`;

export const CalculationsHeader = styled.span`
  margin-left: 6px;
`;

export const CalculationsTitle = styled.div`
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 0.3px;
  color: ${colors.grey7};
`;

export const CalculationDescription = styled.div`
  font-size: 11px;
  font-weight: 400;
  color: ${colors.grey6};
  margin: 8px 0 16px;
`;

export const CalculationTable = styled.div`
  display: flex;
`;

export const CalculationTableDataRow = styled.div`
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0.3px;
  color: ${colors.grey7};
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const CalculationTableColumn = styled.div<{
  padding?: number;
  width?: number;
}>`
  display: flex;
  font-size: 13px;
  flex-direction: column;
  width: ${(props) => (props.width ? `${props.width}px` : '100%')};
  min-width: ${(props) => (props.width ? `${props.width}px` : '100%')};
  max-width: ${(props) => (props.width ? `${props.width}px` : '100%')};
  padding-left: ${(props) => (props.padding ? `${props.padding}px` : 0)};
`;

export const CalculationTableHeaderRow = styled.div`
  font-size: 13px;
  color: ${colors.grey5};
  font-weight: 400;
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const CalculationTableLeft = styled.div`
  width: 400px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid ${colors.grey2};
`;

export const CalculationTableHeaderCell = styled.div`
  color: ${colors.grey5};
  font-weight: 400;
  margin-bottom: 12px;
  white-space: nowrap;
  padding: 4px 16px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CalculationTableCell = styled.div`
  font-weight: 400;
  letter-spacing: 0.3px;
  color: ${colors.grey7};
  white-space: nowrap;
  padding: 4px 16px;
`;

export const CalculationTableErrorCell = styled(CalculationTableCell)`
  color: ${colors.red1};
`;

export const CalculationTableInfoCell = styled.div`
  width: 20px;
  cursor: pointer;
`;

export const Bold = styled.span`
  font-weight: 700;
`;

export const Row = styled.div<{ highlighted?: boolean }>`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.highlighted ? colors.grey1 : colors.white};
  ${CalculationTableColumn} {
    background-color: ${(props) =>
      props.highlighted ? colors.grey1 : colors.white};
  }
  ${CalculationTableInfoCell} {
    visibility: ${(props) => (props.highlighted ? 'visible' : 'hidden')};
  }
`;

export const LabelRow = styled(Row)`
  margin-bottom: 8px;
`;

export const ConfigurationRow = styled(Row)`
  margin-bottom: 12px;
  align-items: flex-start;
`;

export const IndustryFormActionRow = styled(ConfigurationRow)`
  justify-content: flex-end;
`;

export const IndustryFormActionRowBetween = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;
`;

export const CalculationTableRight = styled.div`
  display: flex;
  flex-direction: column;
  width: 680px;
  overflow-x: auto;
  padding-bottom: 24px;
`;

export const PopoverContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px 32px;
  justify-content: center;
`;

export const PopoverRow = styled.div`
  margin-bottom: 8px;
`;

export const PopoverTitle = styled.div`
  margin-bottom: 16px;
`;

export const SecondaryBlendButton = styled(ApButtonSecondary)`
  margin-left: 24px;
  margin-right: 24px;
`;

export const SecondaryBlendButtonRight = styled(ApButtonSecondary)`
  margin-left: 24px;
`;

export const SecondaryBlendButtonLeft = styled(ApButtonSecondary)`
  margin-right: 24px;
`;

export const BlendDataText = styled.div`
  height: 40px;
  font-weight: 400;
  font-size: 19px;
  line-height: 27px;
  display: flex;
  align-items: center;
`;
